// Pill rendering — used for both deployment status and backfill job status.
// Colors map to semantic tokens so they look right in both themes.

const colors: Record<string, string> = {
  CREATED:
    "bg-surface-2 text-fg-subtle border-border",
  STARTING:
    "bg-warn-100 text-warn-700 border-warn-400/30 dark:bg-warn-500/10 dark:text-warn-400 dark:border-warn-400/30",
  RUNNING:
    "bg-up-100 text-up-700 border-up-400/30 dark:bg-up-500/10 dark:text-up-400 dark:border-up-400/30",
  STOPPING:
    "bg-warn-100 text-warn-700 border-warn-400/30 dark:bg-warn-500/10 dark:text-warn-400 dark:border-warn-400/30",
  STOPPED:
    "bg-surface-2 text-fg-subtle border-border",
  ERROR:
    "bg-down-100 text-down-700 border-down-400/30 dark:bg-down-500/10 dark:text-down-400 dark:border-down-400/30",
  KILLED:
    "bg-down-100 text-down-700 border-down-400/40 dark:bg-down-500/15 dark:text-down-400 dark:border-down-400/40",
  // Backfill statuses
  PENDING: "bg-surface-2 text-fg-subtle border-border",
  SUCCESS:
    "bg-up-100 text-up-700 border-up-400/30 dark:bg-up-500/10 dark:text-up-400 dark:border-up-400/30",
  FAILED:
    "bg-down-100 text-down-700 border-down-400/30 dark:bg-down-500/10 dark:text-down-400 dark:border-down-400/30",
  CANCELLED: "bg-surface-2 text-fg-subtle border-border",
};

export default function StatusPill({
  status,
  size = "sm",
}: {
  status: string;
  size?: "xs" | "sm";
}) {
  const cls = colors[status] ?? "bg-surface-2 text-fg-subtle border-border";
  const sz = size === "xs" ? "text-[10px] px-1.5 py-0" : "text-xs px-2 py-0.5";
  return (
    <span
      className={`inline-block font-mono uppercase tracking-wide rounded border ${sz} ${cls}`}
    >
      {status}
    </span>
  );
}
